import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Container } from "./Container";
import { SHELL } from "@/constants/testIds";

export const TopBar = ({ title, subtitle, showBack = true, action }) => {
  const navigate = useNavigate();
  return (
    <header
      data-testid={SHELL.topBar}
      className="sticky top-0 z-30 bg-brand-tealDeep shadow-[0_6px_18px_-12px_rgba(0,0,0,0.4)]"
    >
      <Container className="flex h-[62px] items-center gap-3 sm:h-[68px]">
        {showBack && (
          <button
            data-testid={SHELL.back}
            aria-label="Go back"
            onClick={() => navigate(-1)}
            className="ps-tap -ml-1 grid h-9 w-9 shrink-0 place-items-center rounded-full bg-white/[0.08] text-brand-cream transition-colors hover:bg-white/[0.16]"
          >
            <ChevronLeft className="h-[18px] w-[18px]" />
          </button>
        )}
        <div className="min-w-0 flex-1 leading-tight">
          <p
            data-testid={SHELL.title}
            className="truncate font-display text-[16px] font-bold text-white"
          >
            {title}
          </p>
          {subtitle && <p className="truncate text-[12.5px] font-medium text-white/55">{subtitle}</p>}
        </div>
        {action}
        {/* Quiet Plattershare mark on every plan's header, using the app's own site icon. */}
        <a
          data-testid={SHELL.brandMark}
          href="https://www.plattershare.com/"
          target="_blank"
          rel="noreferrer"
          aria-label="Plattershare"
          className="ps-tap ml-1 block shrink-0 overflow-hidden rounded-full ring-1 ring-white/20 transition-all duration-300 hover:ring-white/45"
        >
          <img src="/favicon.png" alt="" width="34" height="34" className="h-[34px] w-[34px] object-cover" />
        </a>
      </Container>
    </header>
  );
};
